import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  public static env_var = {
    companyId: 21,
    liveApiUrl: '/ilm_fntest/'
  };

}
